import { render, staticRenderFns } from "./WorkflowView.vue?vue&type=template&id=0af732a4&scoped=true"
import script from "./WorkflowView.vue?vue&type=script&lang=ts"
export * from "./WorkflowView.vue?vue&type=script&lang=ts"
import style0 from "./WorkflowView.vue?vue&type=style&index=0&id=0af732a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af732a4",
  null
  
)

export default component.exports